import { questsManager } from "../../../zApps/Layout/Login/MyPage/components/OpenableCards/QuestsCard/quests/quests";
import { Quest } from "../../../zApps/Layout/Login/MyPage/components/OpenableCards/QuestsCard/quests/types";

export const excludedAchievements = [
    "hiragana-50",
    "hiragana-20",
    "katakana-50",
    "katakana-20",
];

export function getUserStudyAchievements(achievements: string[]): Quest[] {
    return questsManager
        .getStudyQuests()
        .filter(
            q =>
                achievements.includes(q.questKey) &&
                !excludedAchievements.includes(q.questKey)
        );
}
